{
    "NAME": "ElencoStatoModuloTelefonicoLingua",
    "TelModuleStatusList_Title": "Stato del modulo telefonico",
    "TelModuleStatusList_Column_TelSys": "Server di telefonia",
    "TelModuleStatusList_Column_ClassName": "Nome della classe",
    "TelModuleStatusList_Column_Type": "Tipo",
    "TelModuleStatusList_Column_Version": "Versione",
    "TelModuleStatusList_Column_Status": "Stato",
    "TelModuleStatusList_Column_LastError": "Ultimo errore",
    "TelModuleStatusList_Column_LastErrorDateTime": "Data\/ora dell'ultimo errore",
    "TelModuleStatusList_Empty": "Non sono disponibili informazioni sullo stato del modulo telefonico."
}